import { DAYS, formatScheduleTime as formatTime } from "@/lib/utils/schedule";

type BusinessHoursCardProps = {
  schedule?: Record<string, { open: string; close: string }[]>;
};

export function BusinessHoursCard({ schedule }: BusinessHoursCardProps) {
  if (!schedule || Object.keys(schedule).length === 0) return null;

  return (
    <div className="space-y-1">
      {DAYS.map((day) => {
        const slots = schedule[day];
        return (
          <div key={day} className="flex items-start justify-between text-sm">
            <span className="text-muted-foreground capitalize w-24 shrink-0">{day}</span>
            {slots && slots.length > 0 ? (
              <div className="text-right space-y-0.5">
                {slots.map((slot, i) => (
                  <p key={i}>
                    {formatTime(slot.open)} – {formatTime(slot.close)}
                  </p>
                ))}
              </div>
            ) : (
              <span className="text-muted-foreground">Closed</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
